export const SHIPMENTMETHOD_LOADING = "SHIPMENTMETHOD_LOADING";
export const SHIPMENTMETHOD_RESET = "SHIPMENTMETHOD_RESET";
export const GET_SHIPMENTMETHOD = "GET_SHIPMENTMETHOD";
export const GET_SHIPMENTMETHOD_SUCCESS = "GET_SHIPMENTMETHOD_SUCCESS";
export const GET_SHIPMENTMETHOD_FAIL = "GET_SHIPMENTMETHOD_FAIL";
export const DELETE_SHIPMENTMETHOD = "DELETE_SHIPMENTMETHOD"
export const DELETE_SHIPMENTMETHOD_SUCCESS = "DELETE_SHIPMENTMETHOD_SUCCESS"
export const DELETE_SHIPMENTMETHOD_FAIL = "DELETE_SHIPMENTMETHOD_FAIL"
export const UPDATE_SHIPMENTMETHOD = "UPDATE_SHIPMENTMETHOD"
export const UPDATE_SHIPMENTMETHOD_SUCCESS = "UPDATE_SHIPMENTMETHOD_SUCCESS"
export const UPDATE_SHIPMENTMETHOD_FAIL = "UPDATE_SHIPMENTMETHOD_FAIL"
export const ADD_NEW_SHIPMENTMETHOD = "ADD_NEW_SHIPMENTMETHOD"
export const ADD_SHIPMENTMETHOD_SUCCESS = "ADD_SHIPMENTMETHOD_SUCCESS"
export const ADD_SHIPMENTMETHOD_FAIL = "ADD_SHIPMENTMETHOD_FAIL"